module.exports = __webpack_public_path__ + "static/media/pink-t.77f87f91.svg";